import React, { Fragment, useState } from "react";
import apiEndPoint from "../../../utils/apiEndPoint";
import { useNavigate } from "react-router-dom";
import OtpInput from 'react-otp-input';
import { loadFromLocalStorage, removeToLocalStorage, saveToLocalStorage } from "../../../utils/LocalStorageUtils";
import { apiCall, failedMessage, setDefaultHeader, successMessage } from "../../../utils/httpClient";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import { CardBody } from "reactstrap";

function Verification() {
  const urlParams = new URLSearchParams(window.location.search);
  const navType = urlParams.get('type');
  const [otp, setOtp] = useState('');
  const [errorMessage, setErrorMessage] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [isLoadingR, setLoadingR] = useState(false);
  const navigate = useNavigate();
  const validation = () => {
    let isError = true;
    let errorMessage = {};
    if (otp === undefined || otp === "" || otp.length < 4) {
      isError = false;
      errorMessage["otp"] = "Please enter OTP";
    }
    setErrorMessage(errorMessage);
    return isError;
  };
  const handleSubmit = async () => {
    if (validation()) {
      setLoading(true)
      const params = {
        "email": loadFromLocalStorage('EMAIL_ADDRESS'),
        "otp": otp,
      }
      const { data } = await apiCall('post', apiEndPoint.OTPVERIFY, params);
      if (data.status !== 200) {
        failedMessage(data.message);
      }
      if (data.status === 200) {
        successMessage(data.message)
        if (navType === 'forgotpassword') {
          navigate('/forgotpassword')
        } else {
          removeToLocalStorage("EMAIL_ADDRESS")
          navigate('/login')
        }
      }
      setLoading(false);
    }
  }
  const handleResentCode = async () => {
      setLoadingR(true)
      const params = {
        "email": loadFromLocalStorage('EMAIL_ADDRESS'),
      }
      const { data } = await apiCall('post', apiEndPoint.RESENTOTP, params);
      if (data.status !== 200) {
        failedMessage(data.message);
      }
      if (data.status === 200) {
        successMessage(data.message)
      }
      setLoadingR(false);
  }
  return (
    <Fragment>
      <section className="login-section1">
        <Container fluid>
          <Row className="justify-content-md-center">
            <Col xs lg="5">
              <Card className="mt-4 login-form">
                <CardBody>
                  <div style={{ display: 'flex' }} className="mt-2 align-items-center justify-content-md-center">
                    <center>
                      <h4 className="mt-2">OTP Verification</h4>
                      <small>A verification code has been sent to your <br /> {loadFromLocalStorage('EMAIL_ADDRESS')}</small>
                    </center>
                  </div>
                  <form>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-lg-12 mt-2">
                          <div className="input-field-box">
                            <center>
                              <div className="mt-2 mb-4">
                                <h5>Enter verification code</h5>
                              </div>

                              <OtpInput
                                value={otp}
                                onChange={setOtp}
                                inputStyle={{ width: 40, height: 40 }}
                                containerStyle={{ justifyContent: 'center' }}
                                shouldAutoFocus
                                numInputs={6}
                                renderSeparator={<span style={{ marginLeft: 5, marginRight: 5 }}>{" - "}</span>}
                                renderInput={(props) => <input {...props} />}
                              />
                              {errorMessage.otp && <span className="er-msg-show">{errorMessage.otp}</span>}
                            </center>
                          </div>
                        </div>
                      </div>
                      <center style={{ display: 'flex' }} className="mt-2 justify-content-evenly">
                        <Button onClick={() => handleResentCode()} className="back-btn" disabled={isLoadingR}>{isLoadingR ? <Spinner animation="border" size="sm" role="status" /> : 'Resent'}</Button>
                        <Button onClick={() => handleSubmit()} className="back-btn" disabled={isLoading}>{isLoading ? <Spinner animation="border" size="sm" role="status" /> : 'Submit'}</Button>
                      </center>
                    </div>
                  </form>

                  <p className="pos-adj mt-4">
                    Back to <a onClick={() => {
                      navigate("/login");
                    }}> Login </a>
                  </p>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
}

export default Verification;